import { Injectable, OnDestroy  } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectIsEnablePALCreateWireTrxn } from '../../feature-flags/reducers';
import { selectPalWiresEnabled } from '../../authorize/reducers';

@Injectable({
  providedIn: 'root'
})
export class ValidateWireFlagsService implements OnDestroy {
  enablePalCreateWireTxn: boolean = false;
  hasAccessMoveMoneyPalWireFirm: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private store: Store) {
    combineLatest([
      this.store.select(selectIsEnablePALCreateWireTrxn),
      this.store.select(selectPalWiresEnabled),
    ]).pipe(takeUntil(this.destroy$)).subscribe(([enablePalCreateWireTxn, hasAccessMoveMoneyPalWireFirm]) => {
      this.enablePalCreateWireTxn = enablePalCreateWireTxn;
      this.hasAccessMoveMoneyPalWireFirm = hasAccessMoveMoneyPalWireFirm;
    }); 
   }

  enablePalWireCreateTransaction(): boolean {
    return this.enablePalCreateWireTxn || this.hasAccessMoveMoneyPalWireFirm;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
